import { render, staticRenderFns } from "./TrendCanvas.vue?vue&type=template&id=60c6cf46&scoped=true&"
import script from "./TrendCanvas.vue?vue&type=script&lang=js&"
export * from "./TrendCanvas.vue?vue&type=script&lang=js&"
import style0 from "./TrendCanvas.vue?vue&type=style&index=0&id=60c6cf46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c6cf46",
  null
  
)

export default component.exports